





























import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import dayjs from "dayjs";
@Component({
    components: {
      
    },
})
export default class headPanel3 extends Vue {
    public $refs: {
    };
    @Prop({
        default:''
    })
    title:String;
    @Prop({
        default:false
    })
    isShowHome:Boolean;
    @Prop({
        default:''
    })
    allottype
    @Prop({
        default:false
    })
    needCharge:Boolean;
    created() {
    }
    mounted() {
       
        
    }
    goback(){
        if(this.allottype){
            localStorage.setItem('allotactive',this.allottype);
        }
        if(this.needCharge){
            this.$emit('goBacknew');
            return;
        }
        this.$router.go(-1);
    }

    logoutFun(){
        if(this.needCharge){
            this.$emit('goBackHome')
            return;
        }
        this.$router.push("/pad/mainPage/index")
    }
    

   

   
   
}



// WEBPACK FOOTER //
// ./node_modules/_vue-loader@14.2.4@vue-loader/lib/selector.js?type=script&index=0!./src/components/pad/headPanel3.vue